<template>
  <div class="form-page">
    <!-- phone -->
    <div v-if="showInput" class="form-input__wrap">
      <input
        :type="history[currentStep].field.type"
        inputmode="number"
        class="form-input"
        @keydown="handleKeydown"
        @change="handleChange"
        :placeholder="history[currentStep].field.placeholder"
        v-model="inputVal"
        :name="history[currentStep].name"
        v-bind:class="{error: history[currentStep].showError || invalidFromBackend}"
        required>
      <span
        class="form-input-floating-label"
        v-bind:class="{error: history[currentStep].showError || invalidFromBackend}"
      >{{history[currentStep].field.label}}</span>
    </div>
    <span class="error-message" v-if="history[currentStep].showError || invalidFromBackend">
      {{history[currentStep].field.error}}
    </span>
    <Checkbox
      v-if="history[currentStep].name === 'phone'"
      name="agreements"
      :show-error="!checked && history[currentStep].showCheckboxError"
      v-model="checked"
      @change="checkboxChanged"
    >
      <p v-html="updatedPrivacyCheckboxText" />
    </Checkbox>
    <CollapsibleCheckbox
      v-if="history[currentStep].name === 'phone' && +country === 1"
      :value="remarketingState.all"
      :show-error="history[currentStep].showCheckboxError && !remarketingState.all"
      :opened="false"
      @change="updateMailingCheckboxes('all', $event)"
    >
      <template #text>
        <p class="checkbox-text">
          Quiero recibir  información sobre productos y servicios adaptados a mis necesidades por parte de {{ siteName }}. Puedes darte de baja en cualquier momento haciendo clic en el enlace de cancelación de <a :href="`https://unsub.${hostName}/ES/gdpr`" target="_blank">cancelación</a>.
        </p>
      </template>
      <template #content>
        <p class="checkbox-text">
          Estoy de acuerdo en recibir información comercial de Fininity OÜ y sus marcas afiliadas a través de:
        </p>
        <Checkbox
          name="agreements_email"
          :show-error="history[currentStep].showCheckboxError && !remarketingState.email"
          v-model="remarketingState.email"
          @change="updateMailingCheckboxes('email')"
        >
          <p class="checkbox-text">Correos electrónicos a la dirección que proporcioné en el formulario de contacto</p>
        </Checkbox>
        <Checkbox
          name="agreements_sms"
          :show-error="history[currentStep].showCheckboxError && !remarketingState.sms"
          v-model="remarketingState.sms"
          @change="updateMailingCheckboxes('sms')"
        >
          <p class="checkbox-text">Mensajes SMS al número de teléfono que proporcioné en el formulario de contacto</p>
        </Checkbox>
        <Checkbox
          name="agreements_whatsapp"
          :show-error="history[currentStep].showCheckboxError && !remarketingState.whatsapp"
          v-model="remarketingState.whatsapp"
          @change="updateMailingCheckboxes('whatsapp')"
        >
          <p class="checkbox-text">Mensajes por WhatsApp</p>
        </Checkbox>
      </template>
    </CollapsibleCheckbox>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Inputmask from 'inputmask'
import ModalComponent from '../assetComponents/ModalComponent'
import Checkbox from '../assetComponents/Checkbox'
import CollapsibleCheckbox from "../assetComponents/CollapsibleCheckbox.vue";

export default {
  name: 'Phone',
  data () {
    return {
      inputVal: '',
      checked: false,
      im: {},
      remarketingState: {
        all: false,
        email: false,
        sms: false,
        whatsapp: false,
      },
    }
  },
  components: {CollapsibleCheckbox, Checkbox },
  computed: {
    isValid () {
      const regex = this.history[this.currentStep].field.reg
      if (!regex) return
      const regexNoSpaces = regex.split('\\s').join('')
      const valNoSpaces = this.inputVal.split(' ').join('')
      return (
        new RegExp(regex).test(this.inputVal) ||
        new RegExp(regexNoSpaces).test(this.inputVal) ||
        new RegExp(regex).test(valNoSpaces) ||
        new RegExp(regexNoSpaces).test(valNoSpaces)
      )
    },
    invalidFromBackend () {
      let result = false
      let values = this.history[this.currentStep].invalidValues
      if (values && this.phonePrefix) {
        values = [...values, ...values.map(x => x.slice(this.phonePrefix.length))]
      }
      if (values && (values.indexOf(this.inputVal) > -1 || values.indexOf(this.inputVal.split(' ').join('')) > -1)) result = true
      return result
    },
    phonePrefix () {
      let phonePrefix = ''
      if (+this.additionalParams.country === 9) phonePrefix = '+84'
      if (+this.additionalParams.country === 10) phonePrefix = '+94'
      return phonePrefix
    },
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      provider: state => state.additionalParams.provider,
      country: state => state.additionalParams.country,
      showInput: state => state.showInput,
      accepted: state => state.additionalParams.is_terms_accepted,
      privacyCheckboxText: state => {
        if (window.customPrivacyCheckboxText) return window.customPrivacyCheckboxText
        const crezuCheckboxText = state.config.params.privacyCheckboxText
        const landingCheckboxText = state.config.params.privacyCheckboxTextLanding
        const hostname = window.location.hostname
        if (['cashspace.es', 'finteres.es'].includes(hostname)) return landingCheckboxText
        const sites = ['crezu', 'andacredito', 'pezetita', 'finteres', 'cashspace', 'tengeplus']
        for (const site of sites) {
          if (hostname.includes(site)) return crezuCheckboxText
        }
        return landingCheckboxText
      },
      additionalParams: state => state.additionalParams,
    }),
    hostName() {
      return window.location.hostname
    },
    siteName() {
      const domainParts = window.location.hostname.replace(/^www\./, '').split('.')
      const sitename = domainParts[0] || window.location.hostname
      return sitename.charAt(0).toUpperCase() + sitename.slice(1)
    },
    updatedPrivacyCheckboxText() {
      return (this.privacyCheckboxText || '').split('{{sitename}}').join(this.siteName)
    }
  },
  mounted () {
    console.log('mounted triggered')
    this.addMask()
    let previosVal = this.history[this.currentStep].value || ''
    console.log('previous val before:', previosVal)
    if (previosVal.includes(this.phonePrefix.split(' ').join(''))) previosVal = previosVal.slice(this.phonePrefix.length)
    if (window.location.hostname === 'walletpals.com') previosVal = previosVal.split('+').join('').slice(2)
    if (+this.additionalParams.country === 7 && previosVal.length === 13) previosVal = previosVal.slice(4)
    console.log('Insert previous phone number:', previosVal)
    this.inputVal = previosVal
    this.checked = !!this.accepted
    this.remarketingState = {
      all: !!this.accepted,
      email: !!this.accepted,
      sms: !!this.accepted,
      whatsapp: !!this.accepted,
    }
    if (this.history[this.currentStep].name !== 'phone') this.checked = true
    this.updatePhone()
  },
  watch: {
    inputVal: function (val, oldVal) {
      let formattedVal = (this.phonePrefix + val).replace(/[ ,.]/g, '')
      this.$store.commit('UPDATE_FIELD', { isValid: this.isValid, value: formattedVal })
      localStorage.setItem('phone', formattedVal)
    },
    showInput: function (val, oldVal) {
      if (val) {
        this.$nextTick(function () {
          this.addMask()
        })
      }
    }
  },
  methods: {
    checkboxChanged () {
      let val = this.checked ? 'on' : ''
      if (+this.country === 1 && !this.remarketingState.all) val = ''
      this.$store.commit('CHANGE_ADDITIONAL_PARAMS', { is_terms_accepted: val })
    },
    handleKeydown (e) {
      if (e.keyCode === 13) {
        this.$store.dispatch('nextStepPrepare', +1)
      }
    },
    handleChange (e) {
      this.inputVal = e.target.value
    },
    addMask () {
      if (this.im.remove) this.im.remove()
      let prefix = this.history[this.currentStep].field.value
      if (prefix && prefix.indexOf('9') > -1) prefix = prefix.split('9').join('\\9')
      console.log('PREFIX:', prefix)
      console.log('MASK:', prefix + this.history[this.currentStep].field['game-mask'])
      this.im = new Inputmask(prefix + this.history[this.currentStep].field['game-mask'], {
        positionCaretOnClick: 'radixFocus',
        showMaskOnHover: false
      })
      setTimeout(() => {
        this.im.mask(document.getElementsByName(this.history[this.currentStep].name)[0])
      }, 50)
    },
    updatePhone () {
      // feature for get new value after inserting data and updating with inputmask
      setTimeout(() => {
        let selector = document.getElementsByName(this.history[this.currentStep].name)[0]
        if (selector) this.inputVal = selector.value
        console.log('phone updated after 150 ms:', this.inputVal)
      }, 150)
    },
    showModal (e) {
      e.preventDefault()
      console.log('modal')
      this.$FModal.show(
        {
          component: ModalComponent,
        },
        {
          content: this.privacySecondCheckboxModalText
        }
      )
    },
    updateMailingCheckboxes(name, allValue) {
      if (name === 'all') {
        if (allValue !== undefined) {
          this.remarketingState = {
            all: allValue,
            email: allValue,
            sms: allValue,
            whatsapp: allValue,
          }
        } else {
          this.remarketingState.email = this.remarketingState.sms = this.remarketingState.whatsapp = this.remarketingState.all
        }
      } else {
        if (this.remarketingState.email && this.remarketingState.sms && this.remarketingState.whatsapp) this.remarketingState.all = true
        else if (!this.remarketingState.email || !this.remarketingState.sms || !this.remarketingState.whatsapp) this.remarketingState.all = false
      }
      this.checkboxChanged()
    },
  }
}
</script>

<style lang="css" scoped>
.form-page {
  .checkbox-text {
    color: var(--white-sixty);
    font-size: 14px;
    line-height: 21px;

    &--bold {
      font-weight: 700;
    }

    a {
      color: var(--white);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fields/Phone.vue